import React, { useState, useContext, useEffect } from 'react';
import {useLocation, useNavigate, NavLink} from 'react-router-dom';
import { AuthContext } from './authcontext';
import '../navigation.css';
import { useCart } from './context4cart';
import { useAuth } from "./authcontext";






const NavbarResponsive = () => {

    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const {loggedIn, userData} = useContext(AuthContext);
    const {user} = useAuth();
    const userTyp = user?.typ;
    const { handleLogout } = useContext(AuthContext);
    const { cartItemCount, wishlistItemCount } = useCart();
   



    useEffect(() => {
        const navLinks = document.querySelectorAll('.nav-Link');
        navLinks.forEach(link => {
            const parent = link.parentElement;
            if (link.getAttribute('href') === location.pathname) {
                parent.classList.add('active');
            } else {
                parent.classList.remove('active');
            }
            
         });
    }, [location]);



    const toggleMenu = () => {
        setIsOpen(!isOpen);
    }

    return (
        <nav className="navbar navbar-expand-lg pgnav">
          <div className="container-fluid">
            
            <button className="navbar-toggler"  onClick={toggleMenu}> 
              {isOpen ? (
                <img src="/assets/img/icons/openBook_w_32.png" alt="Menu" />
              ) : (
                <img src="/assets/img/icons/closedBook_w_32.png" alt="Menu Icon2" />
              )}
            </button>
            <div className="navContainer">
                <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`}>
                
                
                        <>
                            {!loggedIn ? (
                                <div className="navigationsLeiste">
                                <ul className="navRight">
                                    <li className="nav-item">
                                    <NavLink className="nav-link iconNavLogin" to="/login" activeClassName="active">
                                        <span className="nav-icon-login"></span>
                                        <span className="nav-text">Anmelden</span>
                                    </NavLink>
                                    </li>
                                </ul>
                                </div>
                            ) : userTyp === 'A' ? (
                                <div className="navigationsLeiste">
                                <ul className="navRight">
                                    <li className="nav-item">
                                    <NavLink className="nav-link iconNavPrefs" to="/admin" onClick={toggleMenu} activeClassName="active">
                                        <span className="nav-icon-prefs"></span>
                                        <span className="nav-text">Einstellungen</span>
                                    </NavLink>
                                    </li>
                                    <li className="nav-item">
                                    <NavLink className="nav-link iconNavPrefs" to="/texte" onClick={toggleMenu} activeClassName="active">
                                        <span className="nav-icon-prefs"></span>
                                        <span className="nav-text">Texte</span>
                                    </NavLink>
                                    </li>
                                    <li className="nav-item">
                                    <NavLink className="nav-link iconNavLogout" to="/" onClick={handleLogout} activeClassName="active">
                                        <span className="nav-icon-logout"></span>
                                        <span className="nav-text">Abmelden</span>
                                    </NavLink>
                                    </li>
                                </ul>
                                </div>
                            ) : (
                                <div className="navigationsLeiste">
                                <ul className="navLeft">
                                    <li className="nav-item">
                                    <NavLink className="nav-link iconNavSearch" to="/suche" onClick={toggleMenu} activeClassName="active">
                                        <span className="nav-icon-search"></span>
                                        <span className="nav-text">Suche</span>
                                    </NavLink>
                                    </li>
                                    <li className="nav-item">
                                    <NavLink className="nav-link iconNavWK" to="/warenkorb" onClick={toggleMenu} activeClassName="active">
                                        <span className="nav-icon-wk">
                                        {cartItemCount > 0 && <span className="cartBadge">{cartItemCount}</span>}
                                        </span>
                                        <span className="nav-text">Warenkorb</span>
                                    </NavLink>
                                    </li>
                                    <li className="nav-item">
                                    <NavLink className="nav-link iconNavList" to="/merkliste" onClick={toggleMenu} activeClassName="active">
                                        <span className="nav-icon-list">
                                        {wishlistItemCount > 0 && <span className="cartBadge">{wishlistItemCount}</span>}
                                        </span>
                                        <span className="nav-text">Merkliste</span>
                                    </NavLink>
                                    </li>
                                    <li className="nav-item">
                                    <NavLink className="nav-link iconNavHistory" to="/bestellbuch" onClick={toggleMenu} activeClassName="active">
                                        <span className="nav-icon-history"></span>
                                        <span className="nav-text">Bestellbuch</span>
                                    </NavLink>
                                    </li>
                                </ul>

                                <ul className="navRight">
                                    
                                    <li className="nav-item">
                                    <NavLink className="nav-link iconNavLogout" to="/" onClick={handleLogout} activeClassName="active">
                                        <span className="nav-icon-logout"></span>
                                        <span className="nav-text">Abmelden</span>
                                    </NavLink>
                                    </li>
                                </ul>
                                </div>
                            )}
                            </>









                    </div>



          </div>
          </div> 
        </nav>
      );

};


 
export default NavbarResponsive;


/*    
<>
  {!loggedIn ? (
    <div className="navigationsLeiste">
      <ul className="navRight">
        <li className="nav-item">
          <NavLink className="nav-link iconNavLogin" to="/login" activeClassName="active">
            <span className="nav-icon-login"></span>
            <span className="nav-text">Anmelden</span>
          </NavLink>
        </li>
      </ul>
    </div>
  ) : userTyp === 'A' ? (
    <div className="navigationsLeiste">
      <ul className="navRight">
        <li className="nav-item">
          <NavLink className="nav-link iconNavPrefs" to="/einstellungen" onClick={toggleMenu} activeClassName="active">
            <span className="nav-icon-prefs"></span>
            <span className="nav-text">Einstellungen</span>
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink className="nav-link iconNavLogout" to="/" onClick={handleLogout} activeClassName="active">
            <span className="nav-icon-logout"></span>
            <span className="nav-text">Abmelden</span>
          </NavLink>
        </li>
      </ul>
    </div>
  ) : (
    <div className="navigationsLeiste">
      <ul className="navLeft">
        <li className="nav-item">
          <NavLink className="nav-link iconNavSearch" to="/suche" onClick={toggleMenu} activeClassName="active">
            <span className="nav-icon-search"></span>
            <span className="nav-text">Suche</span>
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink className="nav-link iconNavWK" to="/warenkorb" onClick={toggleMenu} activeClassName="active">
            <span className="nav-icon-wk">
              {cartItemCount > 0 && <span className="cartBadge">{cartItemCount}</span>}
            </span>
            <span className="nav-text">Warenkorb</span>
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink className="nav-link iconNavList" to="/merkliste" onClick={toggleMenu} activeClassName="active">
            <span className="nav-icon-list"></span>
            <span className="nav-text">Merkliste</span>
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink className="nav-link iconNavHistory" to="/bestellbuch" onClick={toggleMenu} activeClassName="active">
            <span className="nav-icon-history"></span>
            <span className="nav-text">Bestellbuch</span>
          </NavLink>
        </li>
      </ul>

      <ul className="navRight">
        
        <li className="nav-item">
          <NavLink className="nav-link iconNavLogout" to="/" onClick={handleLogout} activeClassName="active">
            <span className="nav-icon-logout"></span>
            <span className="nav-text">Abmelden</span>
          </NavLink>
        </li>
      </ul>
    </div>
  )}
</>

*/